import React from 'react'
import { Route, Redirect } from 'react-router-dom'

// TODO this simulates authentication.
// Use a proper authentication.
export const fakeAuth = {
    isAuthenticated: true,
    authenticate(cb) {
        fakeAuth.isAuthenticated = true
        setTimeout(cb, 100) // fake async
    },
    signout(cb) {
        fakeAuth.isAuthenticated = false
        setTimeout(cb, 100)
    },
}

// Wrap router for passing props to child components.
const Authroute = ({ children, ...rest }) => {
    return (
        <Route
            {...rest}
            render={({ location }) =>
                fakeAuth.isAuthenticated ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: location },
                        }}
                    />
                )
            }
        />
    )
}

export default Authroute
